import React, { useState } from "react";
import styled from "styled-components";
import {
    BlockCollab,
    BlockTitleCollab,
    BadgeCollab,
    FieldGrid,
    FieldFull,
    Field,
    FieldInput,
    Req,
    TagGroup,
    Tag,
    SInput,
} from "../index";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { ErrorMessage } from "../../../common/styles";

const CIVIL_OPTIONS = [
    { label: "Célibataire", dateField: null, id: 1 },
    { label: "Marié(e)", dateField: "Date du mariage", id: 2 },
    { label: "Divorcé(e)", dateField: "Date du divorce", id: 3 },
    { label: "Veuf / veuve", dateField: null, id: 4 },
    {
        label: "Partenariat enregistré",
        dateField: "Date du partenariat enregistré",
        id: 5,
    },
];

export default function BlockEtatCivil() {
    const {
        control,
        setValue,
        formState: { errors },
    } = useFormContext();
    const watchMaritalStatusId = useWatch({
        name: "personal_infos.marital_status",
        control,
    });
    const current = CIVIL_OPTIONS.find((o) => o.id === watchMaritalStatusId);
    return (
        <BlockCollab>
            <BlockTitleCollab>
                État civil <BadgeCollab>À compléter par vous</BadgeCollab>
            </BlockTitleCollab>

            <FieldGrid>
                <FieldFull>
                    <label>
                        Situation familiale <Req>*</Req>
                    </label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value } }) => {
                            return (
                                <TagGroup>
                                    {CIVIL_OPTIONS.map((opt) => (
                                        <Tag
                                            key={opt.id}
                                            active={value === opt.id}
                                            onClick={() => {
                                                setValue(
                                                    "personal_infos.couple_registration_date",
                                                    null
                                                );
                                                onChange(opt.id);
                                            }}
                                        >
                                            {opt.label}
                                            {opt.id === 5 && (
                                                <TooltipWrap>
                                                    <TooltipIcon>i</TooltipIcon>
                                                    <TooltipBox>
                                                        PACS exclus
                                                    </TooltipBox>
                                                </TooltipWrap>
                                            )}
                                        </Tag>
                                    ))}
                                </TagGroup>
                            );
                        }}
                        name="personal_infos.marital_status"
                    />
                </FieldFull>

                {current?.dateField && (
                    <Field>
                        <label>{current.dateField}</label>
                        <Controller
                            control={control}
                            render={({
                                field: { onChange, value, name, ref },
                            }) => {
                                return (
                                    <SInput
                                        fluid
                                        ref={ref}
                                        name={name}
                                        value={value}
                                        onChange={(_, i) => onChange(i.value)}
                                        type="date"
                                        error={
                                            errors?.personal_infos
                                                ?.couple_registration_date
                                                ?.message
                                        }
                                    />
                                );
                            }}
                            name="personal_infos.couple_registration_date"
                        />
                        {errors?.personal_infos?.couple_registration_date && (
                            <ErrorMessage
                                content={
                                    errors.personal_infos
                                        .couple_registration_date.message
                                }
                            />
                        )}
                    </Field>
                )}
            </FieldGrid>
        </BlockCollab>
    );
}

const TooltipWrap = styled.div`
    position: relative;
    display: inline-flex;
    align-items: center;

    &:hover > div:last-child {
        display: block;
    }
`;

const TooltipIcon = styled.div`
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: var(--blue-light);
    color: var(--blue);
    font-size: 10px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: help;
    border: 1px solid var(--blue-mid);
    flex-shrink: 0;
`;

const TooltipBox = styled.div`
    display: none;
    position: absolute;
    bottom: calc(100% + 6px);
    left: 50%;
    transform: translateX(-50%);
    background: var(--text);
    color: white;
    font-size: 11px;
    padding: 6px 10px;
    border-radius: var(--radius-sm);
    white-space: nowrap;
    z-index: 50;
    pointer-events: none;

    &::after {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        border: 5px solid transparent;
        border-top-color: var(--text);
    }
`;
